function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { ApiConstants, i18n, InjectorHelper, ThunkHelper } from 'invision-core';
import { stateGo } from 'redux-ui-router';
import LocaleKeys from '../../locales/keys';
import { NOTIFICATION_TIME_LENGTH } from '../../customercare.constants';
export var RETRIEVE_AVAILABLE_TOP_UPS = {
  BEGIN: 'RETRIEVE_AVAILABLE_TOP_UPS_BEGIN',
  SUCCESS: 'RETRIEVE_AVAILABLE_TOP_UPS_SUCCESS',
  FAILURE: 'RETRIEVE_AVAILABLE_TOP_UPS_FAILURE'
};
var RETRIEVE_AVAILABLE_TOP_UPS_EVENTS = [RETRIEVE_AVAILABLE_TOP_UPS.BEGIN, RETRIEVE_AVAILABLE_TOP_UPS.SUCCESS, RETRIEVE_AVAILABLE_TOP_UPS.FAILURE];
var retrieveAvailableTopUpsPromise = function retrieveAvailableTopUpsPromise(dispatch, customerId) {
  return ThunkHelper(dispatch, RETRIEVE_AVAILABLE_TOP_UPS_EVENTS, {
    method: 'post',
    url: 'SubscriberManagement/RetrieveAvailableTopUps',
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId)
  });
};
export var getAvailableTopUps = function getAvailableTopUps(customerId) {
  return function (dispatch) {
    return retrieveAvailableTopUpsPromise(dispatch, customerId);
  };
};
export var SUBMIT_TOP_UP_REQUEST = {
  BEGIN: 'SUBMIT_TOP_UP_REQUEST_BEGIN',
  SUCCESS: 'SUBMIT_TOP_UP_REQUEST_SUCCESS',
  FAILURE: 'SUBMIT_TOP_UP_REQUEST_FAILURE'
};
var SUBMIT_TOP_UP_REQUEST_EVENTS = [SUBMIT_TOP_UP_REQUEST.BEGIN, SUBMIT_TOP_UP_REQUEST.SUCCESS, SUBMIT_TOP_UP_REQUEST.FAILURE];
var submitTopUpPromise = function submitTopUpPromise(dispatch, customerId, topUpDTO) {
  return ThunkHelper(dispatch, SUBMIT_TOP_UP_REQUEST_EVENTS, {
    method: 'post',
    url: 'SubscriberManagement/SubmitTopUp',
    data: {
      PaymentInstrumentIds: [topUpDTO.paymentInstrumentId],
      PricingPlanId: topUpDTO.pricingPlanId,
      ServiceIdentifier: topUpDTO.serviceIdentifier
    },
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId)
  });
};
export var submitTopUp = function submitTopUp(customerId, topUpDTO) {
  return function (dispatch) {
    return submitTopUpPromise(dispatch, customerId, topUpDTO).then(function () {
      dispatch(stateGo('index.customercare.customer.dashboard', {
        customerId: customerId
      }));
      InjectorHelper.getUiNotificationService().success(i18n.translate(LocaleKeys.TOP_UPS.SUCCESS), null, {
        timeOut: NOTIFICATION_TIME_LENGTH
      });
    });
  };
};